// extracted by mini-css-extract-plugin
export default {"item":"TableValuesItem_item__V4nVG","value":"TableValuesItem_value__4onOp"};